import { Campaign } from '../models'

export const getCampaingsFiltered = (text: string, bigList: Campaign[]): Campaign[] => {
  let list: Campaign[] = bigList

  if (text) {
    const textValue = text.toLowerCase()
    list = list.filter(campaign => {
      return (
        campaign?.code?.toLowerCase().includes(textValue) ||
        campaign?.name?.toLowerCase().includes(textValue) ||
        campaign?.owner_user_email?.toLowerCase().includes(textValue) ||
        `${campaign?.discount_vouchers?.length}`.includes(textValue)
      )
    })
  }

  return list
}
